import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';

/**
 * Wrapper that reveals children with animation on scroll.
 * animation: 'fade-up' | 'fade-in' | 'fade-left' | 'fade-right' | 'scale-in'
 */
function ScrollReveal({ children, animation = 'fade-up', delay = 0, threshold = 0.15, className = '', style = {} }) {
    const [ref, isVisible] = useScrollReveal({ threshold, delay });

    return (
        <div
            ref={ref}
            className={`scroll-reveal scroll-${animation} ${isVisible ? 'scroll-visible' : ''} ${className}`}
            style={style}
        >
            {children}
        </div>
    );
}

export default ScrollReveal;
